import { Component, OnInit } from '@angular/core';
import { TimeSheetService } from '../time-sheets/time-sheet.service';
import { ITimeSheet } from '../time-sheets/time-sheets.type';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { TimeSheetStatusEnum } from '../time-sheets/time-sheet-status.enum';
import { SessionService } from '../../core';

@Component({
	selector: 'app-pilotpay-dashboard',
	styleUrls: ['./dashboard.component.scss'],
	templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
	get timeSheetStatusEnum(): any {
		return TimeSheetStatusEnum;
	}

	constructor(
		private sessionService: SessionService,
		private timeSheetService: TimeSheetService,
		private router: Router
	) {}

	public timeSheet: ITimeSheet;
	public timeSheetStartDate: string;
	public previousTsStartDate: string;
	public tsSubmissionDeadline: number;
	public isWarningTimeRange: boolean;
	public isAfterDeadlineWarning: boolean;
	public employeeId: number = this.sessionService.getUser().employeeId;

	public ngOnInit(): void {
		this.getPreviousTsStartDate();
		this.getTimeSheet(this.sessionService.getUser().employeeId, this.previousTsStartDate);
	}

	public getTimeSheet(employeeId: number, date: string): void {
		this.timeSheetService.getCurrentTimeSheet(employeeId, date).subscribe(
			(timeSheet: ITimeSheet) => {
				this.timeSheet = timeSheet;
				this.timeSheetStartDate = this.timeSheet.startDate;

				const currentDate: moment.Moment = moment().utc();
				const monthStart: string = moment
					.utc(this.timeSheetStartDate)
					.add(1, 'month')
					.format('YYYY-MM-DDTHH:mm:ss');
				const lockOutDate: moment.Moment = moment
					.utc(this.timeSheetStartDate)
					.add(1, 'month')
					.add(this.timeSheet.timeSheetLockOutDay - 1, 'day');

				this.isWarningTimeRange = currentDate.isBetween(monthStart, lockOutDate.format('YYYY-MM-DDTHH:mm:ss'));
				this.isAfterDeadlineWarning = currentDate.isAfter(lockOutDate.format('YYYY-MM-DDTHH:mm:ss'));
				this.tsSubmissionDeadline = lockOutDate.diff(currentDate, 'days');
			},
			(error: HttpErrorResponse) => {
				console.error(error);
			}
		);
	}

	public navigate(employeeId: number): void {
		this.router.navigate(['/pilotpay/time-sheets', employeeId], {
			queryParams: { date: this.timeSheet.startDate }
		});
	}

	private getPreviousTsStartDate(): void {
		this.previousTsStartDate = moment
			.utc()
			.set('month', moment(this.timeSheetStartDate).get('month'))
			.subtract(1, 'month')
			.format('YYYY-MM-DDTHH:mm:ss');
	}
}
